import { Injectable } from '@angular/core';
import { CAMBIAR_CONTRASENA, HOST } from 'src/app/global'

import { LoginI } from '../../modelos/login.interface';
import { UsuarioI } from '../../modelos/usuario.interface';
import { EstadoUsuarioI } from '../../modelos/estadoUsuario.intreface';
import { TipoUsuarioI } from '../../modelos/tipoUsuario.interface';
import { fuenteFiviI } from '../../modelos/fuenteFivi.interface';
import { fuenteI } from '../../modelos/fuentes.interface';
import { SuperI } from '../../modelos/superintendecia.interface';
import { TipoEntidadI } from '../../modelos/tipoEntidad.interface';
import { CodigoEntidadI } from '../../modelos/codEntidad.interface';
import { DeptoI } from '../../modelos/departamento.interface';
import { MuniI } from '../../modelos/municipio.interface';
import { EstadoEntiI } from '../../modelos/estadoEntidad.interface';

import { ResponseI } from '../../modelos/response.interface';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OperacionI } from 'src/app/modelos/operacionEsta.interface';
import { histActFuenteI } from 'src/app/modelos/histActFuente.interface';
import { NivelSuperv } from 'src/app/modelos/nivelSupervicon.interface';
import { TipoCredito } from 'src/app/modelos/tipoCredito.interface';
import { SolucViv } from 'src/app/modelos/solucionViv.interface';
import { RangViv } from 'src/app/modelos/rangoViv.interface';
import { Tenedor } from 'src/app/modelos/tenedor.interface';
import { Fte_Parm } from 'src/app/modelos/fuenteParam';
import { histActUsuarioI } from 'src/app/modelos/histActUsuario';
import { RecuperarContrasenaI } from 'src/app/modelos/recuperarContra';
import { ResponseLDAPI } from 'src/app/modelos/responseLDAP';
import { DireccionI } from 'src/app/modelos/direccion';
import { CargueI } from 'src/app/modelos/Cargue';
import { Archivo } from 'src/app/modelos/Archivo';
import { ResponseCargueI } from 'src/app/modelos/ResponseCargue';
import { VarParamI } from 'src/app/modelos/VariableParametrica';
import { NovedadI } from 'src/app/modelos/Novedad';
import { VariableI } from 'src/app/modelos/variable';
import { DivipolaI } from 'src/app/modelos/Divipola';
import { SuperTipoEntidadDTOI } from 'src/app/modelos/SuperTipoEntidaDTO';
import { ConsultaFuenteI } from 'src/app/modelos/ConsultaFuente';
import { VigenciaI } from 'src/app/modelos/VigenciaReporte';
import { PeriodoReporteI } from 'src/app/modelos/PeriodoReporte';
import { PeriodoReporteFiviI } from 'src/app/modelos/PeriodoReporteFivi';
import { FuenteParametroI } from 'src/app/modelos/FuenteParametro';
import { FuenteVariableI } from 'src/app/modelos/FuenteVariable';
import { VistaAnalisisInfI } from 'src/app/modelos/VistaAnalisisInf';
import { FichaAnalisisCHVI } from 'src/app/modelos/FichaAnalisisCHV';
import { EstadoInfoChvI } from 'src/app/modelos/EstadoInformacionChv';
import { ResCargueExcel } from 'src/app/modelos/ResCargueExcel';
import { VistaAdminInfoI } from 'src/app/modelos/VistaAdminInfo';
import { HistEstaInfoI } from 'src/app/modelos/HistorialEstadoInfo';
import { ArchivoCargueAdminInfI } from 'src/app/modelos/ArchivoCargueAdminInf';
import { VistaHistoricoNovedadesI } from 'src/app/modelos/VistaHistoricoNovedades';
import { ActivacionCargueI } from 'src/app/modelos/ActivacionCargue';
import { VistaHistoricoActivacionI } from 'src/app/modelos/VistaHistorialActivacion';
import { EstadoInfoFiviI } from 'src/app/modelos/EstadoInformacionFivi';
import { FichaAnalisisFIVII } from 'src/app/modelos/FichaAnalisisFIVI';
import { ResCargueExcelFivi } from 'src/app/modelos/ResCargueExcelFivi';
import { ActivacionCargueFiviI } from 'src/app/modelos/ActivacionCargueFivi';
import { VistaHistoricoActivacionCargueFiviI } from 'src/app/modelos/VistaHistorialActivacionCargueFivi';
import { Panel1OperativoI } from 'src/app/modelos/Panel1Operativo';
import { Panel2OperativoI } from 'src/app/modelos/Panel2Operativo';
import { Panel3OperativoI } from 'src/app/modelos/Panel3Operativo';
import { InforIndicadoresDtoI } from 'src/app/modelos/InformacionIndicadoresDto';
import { PeriodoTrimestralesFiviDto } from 'src/app/modelos/PeriodosTrimestralesFivi';
import { RespuestaFichaAnalisisCHVdto } from 'src/app/modelos/fichasAnalisis/RespuestaFichaAnalisisCHVdto';
import { cambiarcontrasena } from 'src/app/modelos/autenticacion/cambiarcontrasena';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  url:string = HOST;

  constructor(private http: HttpClient) { }

  //Autenticacion
  //Log in
  loginUser(form:LoginI):Observable<ResponseI>{
    let direccion = this.url + "login";
    return this.http.post<ResponseI>(direccion,form);
  }

  //Autenticacion
  //Recuperar Contraseña
  recuperarContrasena(user : RecuperarContrasenaI):Observable<any>{
    let direccion = this.url + "change_password";
    return this.http.post<any>(direccion, user);
  }

  //Autenticacion
  //cambiar Contraseña
  cambiarContrasena(nueva : cambiarcontrasena):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + CAMBIAR_CONTRASENA;
    const body = nueva;
    return this.http.post<Boolean>(direccion, body, {'headers': header});
  }

  //departamento
  //Listado todos
  getDeptos():Observable<DivipolaI[]>{//Obtener departamentos
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "alldeptos";
    return this.http.get<DivipolaI[]>(direccion,{'headers': header});
  }
  //departamento
  //obtener por id
  getdeptoById(id):Observable<DeptoI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "deptobyid/" + id;
    return this.http.get<DeptoI>(direccion,{'headers': header});
  }
  //departamento
  //obtener por codigo
  getdeptoByCod(cod):Observable<DeptoI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "deptobycod/" + cod;
    return this.http.get<DeptoI>(direccion,{'headers': header});
  }
  //Municipio
  //Lista por id departamento
  getMuniByDepto(id):Observable<DivipolaI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "allmunibydepto/" + id;
    return this.http.get<DivipolaI[]>(direccion,{'headers': header});
  }
  //Municipio
  //obtener por id
  getMuniById(id):Observable<MuniI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "munibyid/" + id;
    return this.http.get<MuniI>(direccion,{'headers': header});
  }
  //Municipio
  //obtener por codigo
  getMuniByCodigo(codi):Observable<DivipolaI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "municipiobycod/" + codi;
    return this.http.get<DivipolaI>(direccion,{'headers': header});
  }
  //Superintendecia
  //Lista todas
  getAllSuper():Observable<VariableI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "allsuperintendenciasvr";
    return this.http.get<VariableI[]>(direccion,{'headers': header});
  }
  //obtener superintendencia por id
  /*getSuperById(id):Observable<SuperI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "superbyid/" + id;
    return this.http.get<SuperI>(direccion,{'headers': header});
  }*/
  //Tipo de entidad
  //Obtener tipos de entidad por codigo superintendencia
  getTiposEntidad(codSuper):Observable<VariableI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "alltipoentidadvr/" + codSuper;
    return this.http.get<VariableI[]>(direccion,{'headers': header});
  }
  //Tipo de entidad
  //obtener tipo de entidad por id
  getTipoEntidadByCod(codigos:SuperTipoEntidadDTOI):Observable<VariableI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "tipoentbycodvr";
    const body = codigos;
    return this.http.post<VariableI>(direccion,body, {'headers': header});
  }
  //Operaciones Estadisticas
  //Lista todas
  getOperacionesEsta():Observable<OperacionI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "operacionesta";
    return this.http.get<OperacionI[]>(direccion,{'headers': header});
  }
  //Operacione Estadistica
  //obtener operacion estadistica por id
  getOperacionById(id):Observable<OperacionI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "operacionbyid/" + id;
    return this.http.get<OperacionI>(direccion,{'headers': header});
  }
  //Estados de Fuentes
  //Lista todos
  getEstadoById(id):Observable<EstadoEntiI>{//obtener Estado por id
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "estadobyid/" + id;
    return this.http.get<EstadoEntiI>(direccion,{'headers': header});
  }

  //Servicios Modulo Directorio
  //Fuentes
  //obtiene todas de tabla FUENTES
  getFuentes():Observable<fuenteI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "AllFuentes";
    return this.http.get<fuenteI[]>(direccion,{'headers': header});
  }
  //Fuentes
  //obtiene informacion de fuente por id
  getFuenteById(id):Observable<fuenteI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fuente/id/" + id;
    return this.http.get<fuenteI>(direccion,{'headers': header});
  }
  //Fuentes
  //Obtener fuentes por operacion estadistica
  getFuentesByOpe(op:OperacionI):Observable<fuenteI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fuentesbyoper/" + op.id;
    const body = op;
    return this.http.get<fuenteI[]>(direccion, {'headers': header});//,body
  }
  //Fuentes
  //Consultar si existe codigo entidad
  existeCodigoFuente(codSuper,codTipoE,codEnti,operacion):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "existecodigofuente/"+codSuper+"/"+codTipoE+"/"+codEnti+"/"+operacion;
    return this.http.get<Boolean>(direccion,{'headers': header});
  }
  //Fuentes
  //Guardar nueva fuente
  guardarNuevaFuente(nuevo:fuenteI):Observable<fuenteI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "nuevafuente";
    const body = nuevo;
    return this.http.post<fuenteI>(direccion,body, {'headers': header});
  }
  //Fuentes
  //Guardar fuente editada
  /*guardarFuenteEditada(fuente:fuenteI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "editarFuenteDesdeEditarFuente";
    const body = fuente;
    return this.http.post<Boolean>(direccion,body, {'headers': header});
  }*/
  //Fuentes
  //Guardar fuente editada
  guardarFuenteEditadaDesdeCaratula(fuente:fuenteI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "editarFuenteDesdeCaratula";
    const body = fuente;
    return this.http.post<Boolean>(direccion,body, {'headers': header});
  }
  //Fuentes
  //guaradar registro en historial de activacion
  guardarHistActiv(actEnti:histActFuenteI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "guardarhist";
    const body = actEnti;
    return this.http.post<Boolean>(direccion,body, {'headers': header});
  }
  //Fuentes
  //Consultar el historial de activacion de una fuente
  getHistFuente(id):Observable<histActFuenteI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "historialfuente/" + id;
    return this.http.get<histActFuenteI[]>(direccion,{'headers': header});
  }

  //PRUEBAS PARA CONSULTAR VARIABLES DE REPORTE
  //Consultar niveles de supervision
  getTodosNivelesSuper():Observable<NivelSuperv[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "nivelsupervicion";
    return this.http.get<NivelSuperv[]>(direccion,{'headers': header});
  }
  //consultar tipos de credito
  getTodosTiposCred():Observable<TipoCredito[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "tipocredito";
    return this.http.get<TipoCredito[]>(direccion,{'headers': header});
  }
  //consultar soluciones dde vivienda
  getTodasSolucionesViv():Observable<SolucViv[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "solucionviv";
    return this.http.get<SolucViv[]>(direccion,{'headers': header});
  }
  //consultar rangos de vivienda
  getTodosRangosViv():Observable<RangViv[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "rangovivienda";
    return this.http.get<RangViv[]>(direccion,{'headers': header});
  }
  //consultar tenedor
  getTodosTenedor():Observable<Tenedor[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "tenedor";
    return this.http.get<Tenedor[]>(direccion,{'headers': header});
  }
  //FIN PRUEBAS PARA CONSULTAR VARIABLES DE REPORTE

  //Fuentes
  //Consultar fuente_parametros chv
  getParametrosFte(id):Observable<FuenteParametroI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "parametroschv/idfte/" + id;
    return this.http.get<FuenteParametroI[]>(direccion,{'headers': header});
  }
  //Fuentes
  //Consultar fuente_variables chv
  getVariablesFte(fteparam:FuenteParametroI):Observable<FuenteVariableI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "itmesparametroschv";
    const body = fteparam;
    return this.http.post<FuenteVariableI[]>(direccion,body, {'headers': header});
  }
  //Fuentes
  //Consultar fuente_parametros fivi
  getParametrosFteFivi(id):Observable<FuenteParametroI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "parametrosfivi/idfte/" + id;
    return this.http.get<FuenteParametroI[]>(direccion,{'headers': header});
  }
  //Fuentes
  //Guardar fuente_parametro editada
  guardarFteParam(fteparam:FuenteParametroI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "guardarftepraram";
    const body = fteparam;
    return this.http.post<Boolean>(direccion,body, {'headers': header});
  }
  //Fuentes
  //Guardar fuente_variable editada
  guardarFteVaria(ftevaria:FuenteVariableI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "guardarftevaria";
    const body = ftevaria;
    return this.http.post<Boolean>(direccion,body, {'headers': header});
  }
  //Fuentes
  //Guardar fuente_parametro editada
  nuevaFteParam(fteparam:Fte_Parm):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "guardarftepraram";
    const body = fteparam;
    return this.http.post<Boolean>(direccion,body, {'headers': header});
  }
  //Fuentes
  //Guardar direccion de la fuente nueva
  guardarDireccionFuente(direc:DireccionI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "guardardireccion";
    const body = direc;
    return this.http.post<Boolean>(direccion,body, {'headers': header});
  }
  //Fuentes
  //Obtener direccion de la fuente a editar
  getDireccionFuente(id):Observable<DireccionI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "direccion/" + id;
    return this.http.get<DireccionI>(direccion,{'headers': header});
  }


  //Servicios Modulo Usuarios
  //Usuario
  //Obtener todos los usuairos
  getAllUsers():Observable<UsuarioI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type', 'application/json').set('Authorization',token);
    let direccion = this.url + "users/";
    return this.http.get<UsuarioI[]>(direccion,{'headers': header});
  }
  //Usuario
  //Obtener estados de usuarios
  getEstados() : Observable<EstadoUsuarioI[]> {
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type', 'application/json').set('Authorization',token);
    let direccion = this.url + "estados";
    return this.http.get<EstadoUsuarioI[]>(direccion,{'headers': header});
  }
  //Usuario
  //Obtener estados de usuarios por id
  getEstadoUsuByID(id) : Observable<EstadoUsuarioI> {
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type', 'application/json').set('Authorization',token);
    let direccion = this.url + "estados/" + id;
    return this.http.get<EstadoUsuarioI>(direccion,{'headers': header});
  }
  //Usuario
  //Obtener tipos de usuarios
  getTipos() : Observable<TipoUsuarioI[]> {
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type', 'application/json').set('Authorization',token);
    let direccion = this.url + "tipos";
    return this.http.get<TipoUsuarioI[]>(direccion,{'headers': header});
  }
  //Usuario
  //Obtener fuente por nit o nombre
  getFuenteByNitRNomb(NitONomb) : Observable<fuenteI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fuente/NN/" + NitONomb;
    return this.http.get<fuenteI>(direccion,{'headers': header});
  }
  //Usuario
  //Obtener id para nueva fuente
  getIdConsecutivo():Observable<String>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "idconsecutivo";
    return this.http.get<String>(direccion,{'headers': header});
  }
  //Usuario
  //Guardar usuario nuevo
  nuevoUsuario(usuario:UsuarioI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "usuarionuevo";
    const body = usuario;
    return this.http.post<Boolean>(direccion,body, {'headers': header});
  }
  //Usuario
  //Guardar usuario nuevo DANE
  nuevoUsuarioDane(usuario:UsuarioI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "usuarionuevodane";
    const body = usuario;
    return this.http.post<Boolean>(direccion,body, {'headers': header});
  }
  //Usuario
  //Editar usuario
  editarUsuario(usuario:UsuarioI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "editaruser";
    const body = usuario;
    return this.http.post<Boolean>(direccion,body, {'headers': header});
  }
  //Usuario
  //Cambiar clave usuario
  nuevaClave(usuario:UsuarioI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "nuevaclave";
    const body = usuario;
    return this.http.post<Boolean>(direccion,body, {'headers': header});
  }
  //Usuario
  //obtiene usuario por id
  obtUsuarioById(id):Observable<UsuarioI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "usuario/" + id;
    return this.http.get<UsuarioI>(direccion,{'headers': header});
  }
  //Usuario
  //Obtener tipos de usuarios dane
  getTipobtenerTipoUDANE() : Observable<TipoUsuarioI[]> {
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type', 'application/json').set('Authorization',token);
    let direccion = this.url + "tiposdane";
    return this.http.get<TipoUsuarioI[]>(direccion,{'headers': header});
  }
  //Usuario
  //Verificar existe usuario por id_fuente
  existeUsuarioFuente(id):Observable<UsuarioI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "existeusuario/" + id;
    return this.http.get<UsuarioI>(direccion,{'headers': header});
  }
  //Usuario
  //Obtener tipo usuario by id
  getTipoUsuarioById(id):Observable<TipoUsuarioI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "tipodane/" + id;
    return this.http.get<TipoUsuarioI>(direccion,{'headers': header});
  }
  //Usuario
  //guardar registro en historial de activacion de usuarios
  saveHistUsuario(nuevoHist:histActUsuarioI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "guardarhistusuario";
    const body = nuevoHist;
    return this.http.post<Boolean>(direccion,body, {'headers': header});
  }
  //Usuario
  //Consultar el historial de activacion del usuario
  getHistoriaUsuario(id):Observable<histActUsuarioI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "historiacti/" + id;
    return this.http.get<histActUsuarioI[]>(direccion,{'headers': header});
  }
  //Usuario
  //obtiene usuario por username
  getUsuarioByUsername(username):Observable<UsuarioI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "users/" + username;
    return this.http.get<UsuarioI>(direccion,{'headers': header});
  }
  //Usuario
  //Consultar usuario LDAP
  getInfoUsuarioDane(username): Observable<ResponseLDAPI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "usersdane/" + username;
    return this.http.get<ResponseLDAPI>(direccion,{'headers': header});
  }

  //Servicios Modulo Parametricas
  //Variable parametrica
  //Lista de Parametricas CHV
  getVariableParametricaChv():Observable<VarParamI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "getparametricaschv";
    return this.http.get<VarParamI[]>(direccion, {'headers': header});
  }
  //Variable parametrica
  //Lista de Parametricas CHV
  getVariableParametricaFivi():Observable<VarParamI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "getparametricasfivi";
    return this.http.get<VarParamI[]>(direccion, {'headers': header});
  }
  //Variable parametrica
  //Parametrica por ID
  getVarParamById(id):Observable<VarParamI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "getVarParamById/" + id;
    return this.http.get<VarParamI>(direccion, {'headers': header});
  }
  //Variable parametrica
  //Editar Parametrica de reporte
  editarParametrica(parametrica:VarParamI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "editarparametrica";
    const body = parametrica;
    return this.http.post<Boolean>(direccion,body, {'headers': header});
  }
  //Variable parametrica
  //Lista de Varibles Por Id de Parametrica
  getVariablesByIdParam(id):Observable<VariableI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "getListVariables/" + id;
    return this.http.get<VariableI[]>(direccion, {'headers': header});
  }
  //Variable parametrica
  //Lista de Varibles Por Id de Parametrica
  getTiposEntidadOrdenCodsuper(id):Observable<VariableI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "getListaTiposEntidad/" + id;
    return this.http.get<VariableI[]>(direccion, {'headers': header});
  }
  //Variable parametrica
  //Nueva Variable
  nuevaVariableReporte(nuevaVariable:VariableI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "nuevaVariable";
    const body = nuevaVariable;
    return this.http.post<Boolean>(direccion,body, {'headers': header});
  }
  //Variable parametrica
  //Superintendencia por codigo
  getSuperByCodigo(cod):Observable<VariableI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "getSuperByCod/" + cod;
    return this.http.get<VariableI>(direccion, {'headers': header});
  }
  //Variable parametrica
  //Lista de divipola
  findAllDeptosMunis():Observable<DivipolaI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "getAllDeptoMuni";
    return this.http.get<DivipolaI[]>(direccion, {'headers': header});
  }

  //Variable parametrica
  //Lista de departamentos
  findAllDeptos():Observable<DivipolaI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "getAllDeptosParametricas";
    return this.http.get<DivipolaI[]>(direccion, {'headers': header});
  }

  //Servicios Modulo Calendario
  //Vigencia
  //nueva vigencia CHV
  nuevaVigencia(nuevaVigencia:VigenciaI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "nuevavigencia";
    const body = nuevaVigencia;
    return this.http.post<Boolean>(direccion,body, {'headers': header});
  }
  //Vigencia
  //nueva vigencia FIVI
  nuevaVigenciaFivi(nuevaVigencia:VigenciaI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "nuevavigenciafivi";
    const body = nuevaVigencia;
    return this.http.post<Boolean>(direccion,body, {'headers': header});
  }
  //Vigencia
  //existe vigencia CHV
  existeVigencia(anio):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "existevigencia/" + anio;
    return this.http.get<Boolean>(direccion, {'headers': header});
  }
  //Vigencia
  //existe vigencia FIVI
  existeVigenciaFivi(anio):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "existevigenciafivi/" + anio;
    return this.http.get<Boolean>(direccion, {'headers': header});
  }
  //Periodos
  //Lista periodos de reporte CHV
  listaPeriodosCalendario():Observable<PeriodoReporteI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "periodoscalendariochv";
    return this.http.get<PeriodoReporteI[]>(direccion, {'headers': header});
  }
  //Periodos
  //Lista periodos de reporte FIVI
  listaPeriodosCalendarioFivi():Observable<PeriodoReporteI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "periodoscalendariofivi";
    return this.http.get<PeriodoReporteI[]>(direccion, {'headers': header});
  }
  //Periodos
  //Crear periodos de reporte CHV trimestrales
  crearPeriodosTrimestresCHV(anio):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "crearcalendariotrimestralchv/" + anio;
    return this.http.get<Boolean>(direccion, {'headers': header});
  }
  //Periodos
  //Crear periodos de reporte FIVI trimestrales
  crearPeriodosTrimestresFivi(anio):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "crearcalendariotrimestralfivi/" + anio;
    return this.http.get<Boolean>(direccion, {'headers': header});
  }
  //Periodos
  //Crear periodos de reporte CHV Mensuales
  crearPeriodosMensualesCHV(anio):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "crearcalendariomensualchv/" + anio;
    return this.http.get<Boolean>(direccion, {'headers': header});
  }
  //Periodos
  //Crear periodos de reporte FIVI Mensuales
  crearPeriodosMensualesFivi(anio):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "crearcalendariomensualfivi/" + anio;
    return this.http.get<Boolean>(direccion, {'headers': header});
  }
  //Periodos
  //editar periodos de reporte CHV
  editarPeriodoCHV(periodo:PeriodoReporteI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "editarperiodo";
    const body = periodo;
    return this.http.post<Boolean>(direccion,body, {'headers': header});
  }
  //Periodos
  //editar periodos de reporte FIVI
  editarPeriodoFivi(periodo:PeriodoReporteFiviI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "editarperiodofivi";
    const body = periodo;
    return this.http.post<Boolean>(direccion,body, {'headers': header});
  }
  //Periodos
  //Perido por id chv
  PeriodoPorId(id):Observable<PeriodoReporteI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "periodochvporid/" + id;
    return this.http.get<PeriodoReporteI>(direccion, {'headers': header});
  }
  //Periodos
  //Perido por id Fivi
  PeriodoFiviPorId(id):Observable<PeriodoReporteFiviI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "periodofiviporid/" + id;
    return this.http.get<PeriodoReporteFiviI>(direccion, {'headers': header});
  }
  //Periodos
  //Perido por id chv
  PeriodoPorConsecutivoAnio(consecutivo, anio):Observable<PeriodoReporteI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "periodochvporConsecutivoAnio/"+consecutivo+"/"+anio;
    return this.http.get<PeriodoReporteI>(direccion, {'headers': header});
  }

  //MODULO ANALISIS DE INFORMACION
  //Servicios Modulo Analisis Informacion chv
  //Listado fuentes-estados chv
  TodosEstadosChv():Observable<VistaAnalisisInfI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "listaestadosinforftechv";
    return this.http.get<VistaAnalisisInfI[]>(direccion, {'headers': header});
  }
  //Listado estados por periodo chv
  EstadosParaPeriodoChv(id):Observable<VistaAnalisisInfI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "estadosinforfteporperiodochv/" + id;
    return this.http.get<VistaAnalisisInfI[]>(direccion, {'headers': header});
  }
  //Estado para fuente por id periodo y id fuente chv
  EstadoInfParaFuente(idperiodo, idfuente):Observable<EstadoInfoChvI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "estadoinformacionfuente/" + idperiodo + "/" + idfuente;
    return this.http.get<EstadoInfoChvI>(direccion, {'headers': header});
  }
  //Consultar estado por ID chv
  ConsultarEstadoInfoPorId(idEstInf):Observable<EstadoInfoChvI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "estadoinformacionfuenteporid/" + idEstInf;
    return this.http.get<EstadoInfoChvI>(direccion, {'headers': header});
  }
  //Guardar estado de cargue para fuente chv
  CambiarEstadoInformacionChv(EstaInf:EstadoInfoChvI, Usuario:String):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "cambiarestadoinformacionanalisischv/" + Usuario;
    const body = EstaInf;
    return this.http.post<Boolean>(direccion,body, {'headers': header});
  }



  /*/FICHAS DE ANALISIS CHV
  //ficha de analisis general chv
  fichaAnalisisGeneralCHV(trimestre, anio):Observable<RespuestaFichaAnalisisCHVdto>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url +"fichaAnalisisGeneralChv/"+trimestre+"/"+anio;
    return this.http.get<RespuestaFichaAnalisisCHVdto>(direccion, {'headers': header});
  }
  //ficha de analisis individual chv
  fichaAnalisisIndividualCHV(trimestre, anio, idFuente):Observable<RespuestaFichaAnalisisCHVdto>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url +"fichaAnalisisIndividualChv/"+trimestre+"/"+anio+"/"+idFuente;
    return this.http.get<RespuestaFichaAnalisisCHVdto>(direccion, {'headers': header});
  }*/

  //FICHAS DE ANALISIS FIVI
  //Listado estados por periodo Fivi
  EstadosParaPeriodoFivi(id):Observable<VistaAnalisisInfI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "estadosinforfteporperiodofivi/" + id;
    return this.http.get<VistaAnalisisInfI[]>(direccion, {'headers': header});
  }
  //Estado informacion para fuente por id periodo y id fuente Fivi
  EstadoInfParaFuenteFivi(idperiodo, idfuente):Observable<EstadoInfoFiviI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "estadoinformacionfuentefivi/" + idperiodo + "/" + idfuente;
    return this.http.get<EstadoInfoFiviI>(direccion, {'headers': header});
  }
  //Estado información para fuente por id Fivi
  ConsultarEstadoInfoFiviPorId(idEstInf):Observable<EstadoInfoFiviI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "estadoinformacionfuentefiviporid/" + idEstInf;
    return this.http.get<EstadoInfoFiviI>(direccion, {'headers': header});
  }
  //Informacion ficha de analisis general mensual valor desembolsos fivi
  //Tabla operacion financiera 1 y 2 fivi
  InformacionFichaGeneralValDesOperFin12(idperido):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichageneralvalordesemoperfinan12/" + idperido;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 1 fivi
  InformacionFichaGeneralValDesOperFin1(idperido):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichageneralvalordesemoperfinan1/" + idperido;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 2 fivi
  InformacionFichaGeneralValDesOperFin2(idperido):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichageneralvalordesemoperfinan2/" + idperido;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 3 fivi
  InformacionFichaGeneralValDesOperFin3(idperido):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichageneralvalordesemoperfinan3/" + idperido;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 1 fivi
  InformacionFichaGeneralValDesOperFin4(idperido):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichageneralvalordesemoperfinan4/" + idperido;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Informacion ficha de analisis general mensual numero de creditos fivi
  //Tabla operacion financiera 1 y 2 fivi
  InformacionFichaGeneralNumCreOperFin12(idperido):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichageneralnumercredioperfinan12/" + idperido;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 1 fivi
  InformacionFichaGeneralNumCreOperFin1(idperido):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichageneralnumercredioperfinan1/" + idperido;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 2 fivi
  InformacionFichaGeneralNumCreOperFin2(idperido):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichageneralnumercredioperfinan2/" + idperido;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 3 fivi
  InformacionFichaGeneralNumCreOperFin3(idperido):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichageneralnumercredioperfinan3/" + idperido;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 4 fivi
  InformacionFichaGeneralNumCreOperFin4(idperido):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichageneralnumercredioperfinan4/" + idperido;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Informacion ficha de analisis general trimestral valor desembolsos fivi
  //Tabla operacion financiera 1 y 2 fivi
  InformacionFichaGeneralTrimestralValDesOperFin12(idperido,trimestre):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichageneraltrimestralvalordesemoperfinan12/" + idperido + "/" + trimestre;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 1 fivi
  InformacionFichaGeneralTrimestralValDesOperFin1(idperido,trimestre):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichageneraltrimestralvalordesemoperfinan1/" + idperido + "/" + trimestre;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 2 fivi
  InformacionFichaGeneralTrimestralValDesOperFin2(idperido,trimestre):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichageneraltrimestralvalordesemoperfinan2/" + idperido + "/" + trimestre;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 3 fivi
  InformacionFichaGeneralTrimestralValDesOperFin3(idperido,trimestre):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichageneraltrimestralvalordesemoperfinan3/" + idperido + "/" + trimestre;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 4 fivi
  InformacionFichaGeneralTrimestralValDesOperFin4(idperido,trimestre):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichageneraltrimestralvalordesemoperfinan4/" + idperido + "/" + trimestre;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Informacion ficha de analisis general trimestral numero de creditos fivi
  //Tabla operacion financiera 1 y 2 fivi
  InformacionFichaGeneralTrimestralNumCreOperFin12(idperido,trimestre):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichageneraltrimestralnumercredioperfinan12/" + idperido + "/" + trimestre;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 1 fivi
  InformacionFichaGeneralTrimestralNumCreOperFin1(idperido,trimestre):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichageneraltrimestralnumercredioperfinan1/" + idperido + "/" + trimestre;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 2 fivi
  InformacionFichaGeneralTrimestralNumCreOperFin2(idperido,trimestre):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichageneraltrimestralnumercredioperfinan2/" + idperido + "/" + trimestre;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 3 fivi
  InformacionFichaGeneralTrimestralNumCreOperFin3(idperido,trimestre):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichageneraltrimestralnumercredioperfinan3/" + idperido + "/" + trimestre;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 4 fivi
  InformacionFichaGeneralTrimestralNumCreOperFin4(idperido,trimestre):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichageneraltrimestralnumercredioperfinan4/" + idperido + "/" + trimestre;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Informacion ficha de analisis individual mensual valor desembolsos fivi
  //Tabla operacion financiera 1 y 2 fivi
  InformacionFichaIndividualValDesOperFin12(idperiodo,ifuente):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichaindividualvalordesemoperfinan12/"+idperiodo+"/"+ifuente;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 1 fivi
  InformacionFichaIndividualValDesOperFin1(idperiodo,ifuente):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichaindividualvalordesemoperfinan1/"+idperiodo+"/"+ifuente;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 2 fivi
  InformacionFichaIndividualValDesOperFin2(idperiodo,ifuente):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichaindividualvalordesemoperfinan2/"+idperiodo+"/"+ifuente;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 3 fivi
  InformacionFichaIndividualValDesOperFin3(idperiodo,ifuente):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichaindividualvalordesemoperfinan3/"+idperiodo+"/"+ifuente;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 1 fivi
  InformacionFichaIndividualValDesOperFin4(idperiodo,ifuente):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichaindividualvalordesemoperfinan4/"+idperiodo+"/"+ifuente;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Informacion ficha de analisis general mensual numero de creditos fivi
  //Tabla operacion financiera 1 y 2 fivi
  InformacionFichaIndividualNumCreOperFin12(idperiodo,ifuente):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichaindividualnumercredioperfinan12/"+idperiodo+"/"+ifuente;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 1 fivi
  InformacionFichaIndividualNumCreOperFin1(idperiodo,ifuente):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichaindividualnumercredioperfinan1/"+idperiodo+"/"+ifuente;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 2 fivi
  InformacionFichaIndividualNumCreOperFin2(idperiodo,ifuente):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichaindividualnumercredioperfinan2/"+idperiodo+"/"+ifuente;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 3 fivi
  InformacionFichaIndividualNumCreOperFin3(idperiodo,ifuente):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichaindividualnumercredioperfinan3/"+idperiodo+"/"+ifuente;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 4 fivi
  InformacionFichaIndividualNumCreOperFin4(idperiodo,ifuente):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichaindividualnumercredioperfinan4/"+idperiodo+"/"+ifuente;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Informacion ficha de analisis individual trimestral valor desembolso fivi
  //Tabla operacion financiera 1 y 2 fivi
  InformacionFichaIndividualTrimestralValDesOperFin12(idperiodo,ifuente,trimestre):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichaindividualtrimestralvalordesemoperfinan12/"+idperiodo+"/"+ifuente+"/"+trimestre;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 1 fivi
  InformacionFichaIndividualTrimestralValDesOperFin1(idperiodo,ifuente,trimestre):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichaindividualtrimestralvalordesemoperfinan1/"+idperiodo+"/"+ifuente+"/"+trimestre;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 2 fivi
  InformacionFichaIndividualTrimestralValDesOperFin2(idperiodo,ifuente,trimestre):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichaindividualtrimestralvalordesemoperfinan2/"+idperiodo+"/"+ifuente+"/"+trimestre;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 3 fivi
  InformacionFichaIndividualTrimestralValDesOperFin3(idperiodo,ifuente,trimestre):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichaindividualtrimestralvalordesemoperfinan3/"+idperiodo+"/"+ifuente+"/"+trimestre;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 4 fivi
  InformacionFichaIndividualTrimestralValDesOperFin4(idperiodo,ifuente,trimestre):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichaindividualtrimestralvalordesemoperfinan4/"+idperiodo+"/"+ifuente+"/"+trimestre;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Informacion ficha de analisis individual trimestral numero de creditos fivi
  //Tabla operacion financiera 1 y 2 fivi
  InformacionFichaIndividualTrimestralNumCreOperFin12(idperiodo,ifuente,trimestre):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichaindividualtrimestralnumercredioperfinan12/"+idperiodo+"/"+ifuente+"/"+trimestre;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 1 fivi
  InformacionFichaIndividualTrimestralNumCreOperFin1(idperiodo,ifuente,trimestre):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichaindividualtrimestralnumercredioperfinan1/"+idperiodo+"/"+ifuente+"/"+trimestre;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 2 fivi
  InformacionFichaIndividualTrimestralNumCreOperFin2(idperiodo,ifuente,trimestre):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichaindividualtrimestralnumercredioperfinan2/"+idperiodo+"/"+ifuente+"/"+trimestre;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 3 fivi
  InformacionFichaIndividualTrimestralNumCreOperFin3(idperiodo,ifuente,trimestre):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichaindividualtrimestralnumercredioperfinan3/"+idperiodo+"/"+ifuente+"/"+trimestre;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Tabla operacion financiera 4 fivi
  InformacionFichaIndividualTrimestralNumCreOperFin4(idperiodo,ifuente,trimestre):Observable<FichaAnalisisFIVII[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fichaindividualtrimestralnumercredioperfinan4/"+idperiodo+"/"+ifuente+"/"+trimestre;
    return this.http.get<FichaAnalisisFIVII[]>(direccion, {'headers': header});
  }
  //Guardar estado de cargue para fuente chv
  CambiarEstadoInformacionFivi(EstaInf:EstadoInfoFiviI, Usuario:String):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "cambiarestadoinformacionanalisisfivi/" + Usuario;
    const body = EstaInf;
    return this.http.post<Boolean>(direccion,body, {'headers': header});
  }


  //MODULO ADMINISTRACION DE INFORMACION
  //Servicios chv
  //Listado estados de informacion para periodo activo chv
  TodosEstadosPeriodoActivoAdminInfoChv():Observable<VistaAdminInfoI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "listestainfoadmininfperiodoactchv";
    return this.http.get<VistaAdminInfoI[]>(direccion, {'headers': header});
  }
  //Listado estados por periodo chv
  EstadosInfoParaPeriodoChv(id):Observable<VistaAdminInfoI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "listestainfoadmininfperiodochv/" + id;
    return this.http.get<VistaAdminInfoI[]>(direccion, {'headers': header});
  }
  //Consultar historico de estado informacion aprobado chv((Esta funcion sirve para las dos operaciones estadisticas))
  HistEstadoInfAprobada(idEstInf, idFuente):Observable<HistEstaInfoI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "consultarhistorialestadoinformacionaprobadoporidestado/"+idEstInf+"/"+idFuente;
    return this.http.get<HistEstaInfoI>(direccion, {'headers': header});
  }
  //Consultar fuente reporto en perido chv
  ConsultaReportoPeriodo(idfte, idperi):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "consultarfuentereportoperiodoseleccionado/" + idfte + "/" + idperi;
    return this.http.get<Boolean>(direccion, {'headers': header});
  }
  //Verificar archivo Excel fuente chv desde administracion de informacion
  VerificarContenidoDocumento(Archivo: ArchivoCargueAdminInfI):Observable<ResponseCargueI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "verificarcarguedesdeadmininfo";
    return this.http.post<ResponseCargueI>(direccion,Archivo, {'headers': header ,reportProgress: true, responseType: 'json'});
  }
  //Confirmo cargue masivo para fuente chv desde administracion de informacion
  CargueConfirmacionChv(Archivo: ArchivoCargueAdminInfI):Observable<ResponseCargueI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "confirmarcarguedesdeadmininfo";
    return this.http.post<ResponseCargueI>(direccion,Archivo, {'headers': header ,reportProgress: true, responseType: 'json'});
  }
  //Consultar supersolidaria puede reportar en perido chv
  ConsultaSupersoliPuedeReportarPeriodo(idperi):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "consultarsupersolireportoperiodoseleccionado/" + idperi;
    return this.http.get<Boolean>(direccion, {'headers': header});
  }
  //Verificar archivo Excel supersolidaria chv desde administracion de informacion
  VerificarContenidoDocumentoSupersoliChv(Archivo: ArchivoCargueAdminInfI):Observable<ResponseCargueI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "verificarcarguesupersolidesdeadmininfo";
    return this.http.post<ResponseCargueI>(direccion,Archivo, {'headers': header ,reportProgress: true, responseType: 'json'});
  }
  //Confirmo cargue masivo de supersolidaria chv desde administracion de informacion
  CargueConfirmacioSupersolinChv(Archivo: ArchivoCargueAdminInfI):Observable<ResponseCargueI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "confirmarcarguesupersolidariadesdeadmininfo";
    return this.http.post<ResponseCargueI>(direccion,Archivo, {'headers': header ,reportProgress: true, responseType: 'json'});
  }
  //Historico de novedades registradas para fuente en perido
  ConsultarNovedadesFuentePeriodo(idfte, idperi):Observable<VistaHistoricoNovedadesI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "consultarnovedadesfuenteperiodo/" + idfte + "/" + idperi;
    return this.http.get<VistaHistoricoNovedadesI[]>(direccion, {'headers': header});
  }
  //Inactivar Cargue chv desde administración de información
  InactivarCargueChv(Objeto: ActivacionCargueI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "inactivarcarguechv";
    return this.http.post<Boolean>(direccion,Objeto, {'headers': header ,reportProgress: true, responseType: 'json'});
  }
  //Activar Cargue desde modal Inactivar chv desde administración de información
  ActivarCargueDesdeInactivarModalChv(Objeto: ActivacionCargueI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "activarcarguedesdeinactivarmodalchv";
    return this.http.post<Boolean>(direccion,Objeto, {'headers': header ,reportProgress: true, responseType: 'json'});
  }
  //Activar Cargue chv desde administración de información
  ActivarCargueChv(Objeto: ActivacionCargueI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "activarcarguechv";
    return this.http.post<Boolean>(direccion,Objeto, {'headers': header ,reportProgress: true, responseType: 'json'});
  }
  //Historial de activación para fuente
  HistorialActivacionCargueChv(idEstInf):Observable<VistaHistoricoActivacionI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "histroialactivacioncarguechv/" + idEstInf;
    return this.http.get<VistaHistoricoActivacionI[]>(direccion, {'headers': header});
  }
  //Servicios FIVI
  //Listado estados de informacion para periodo activo chv
  ListaEstadoInformacionFiviPorPeriodo(id):Observable<VistaAdminInfoI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "fivi/admininfo/listaestadosinformacionporidperiodo/"+id;
    return this.http.get<VistaAdminInfoI[]>(direccion, {'headers': header});
  }
  //Consultar fuente reporto en perido seleccionado Fivi
  ConsultaReportoPeriodoFivi(idfte, idperi):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "consultarfuentefivireportoperiodoseleccionado/" + idfte + "/" + idperi;
    return this.http.get<Boolean>(direccion, {'headers': header});
  }
  //Verificar archivo Excel fuente Fivi desde administracion de informacion
  VerificarContenidoDocumentoFivi(Archivo: ArchivoCargueAdminInfI):Observable<ResponseCargueI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "verificarcarguefividesdeadmininfo";
    return this.http.post<ResponseCargueI>(direccion,Archivo, {'headers': header ,reportProgress: true, responseType: 'json'});
  }
  //Confirmo cargue masivo Fivi desde administracion de informacion
  ConfirmacionCargueMasivoAdminInfoFivi(Archivo: ArchivoCargueAdminInfI):Observable<ResponseCargueI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "confirmarcarguefividesdeadmininfo";
    return this.http.post<ResponseCargueI>(direccion,Archivo, {'headers': header ,reportProgress: true, responseType: 'json'});
  }
  //Inactivar Cargue Fivi desde administración de información
  InactivarCargueFivi(Objeto: ActivacionCargueFiviI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "inactivarcarguefivi";
    return this.http.post<Boolean>(direccion,Objeto, {'headers': header ,reportProgress: true, responseType: 'json'});
  }
  //Activar Cargue desde modal Inactivar Fivi desde administración de información
  ActivarCargueDesdeModalInactivarFivi(Objeto: ActivacionCargueFiviI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "activarcarguedesdemodalinactivarfivi";
    return this.http.post<Boolean>(direccion,Objeto, {'headers': header ,reportProgress: true, responseType: 'json'});
  }
  //Activar Cargue chv desde administración de información
  ActivarCargueFivi(Objeto: ActivacionCargueFiviI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "activarcarguefivi";
    return this.http.post<Boolean>(direccion,Objeto, {'headers': header ,reportProgress: true, responseType: 'json'});
  }
  //Historial de activación para fuente
  HistorialActivacionCargueFivi(idEstInf):Observable<VistaHistoricoActivacionCargueFiviI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "histroialactivacioncarguefivi/" + idEstInf;
    return this.http.get<VistaHistoricoActivacionCargueFiviI[]>(direccion, {'headers': header});
  }


  //MODULO CONTROL OPERATIVO
  //Consultar informacion panel 1 chv
  DatosPanel1OperativoChv(idPeriodo):Observable<Panel1OperativoI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "consultardatosoperativopanel1chv/" + idPeriodo;
    return this.http.get<Panel1OperativoI>(direccion, {'headers': header});
  }
  //Consultar informacion panel 2 chv
  DatosPanel2OperativoChv(idPeriodo):Observable<Panel2OperativoI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "consultardatosoperativopanel2chv/" + idPeriodo;
    return this.http.get<Panel2OperativoI>(direccion, {'headers': header});
  }
  //Consultar informacion panel 3 chv
  DatosPanel3OperativoChv(idPeriodo):Observable<Panel3OperativoI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "consultardatosoperativopanel3chv/" + idPeriodo;
    return this.http.get<Panel3OperativoI[]>(direccion, {'headers': header});
  }
  //Consultar informacion panel 1 fivi
  DatosPanel1OperativoFivi(idPeriodo):Observable<Panel1OperativoI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "consultardatosoperativopanel1fivi/" + idPeriodo;
    return this.http.get<Panel1OperativoI>(direccion, {'headers': header});
  }
  //Consultar informacion panel 2 fivi
  DatosPanel2OperativoFivi(idPeriodo):Observable<Panel2OperativoI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "consultardatosoperativopanel2fivi/" + idPeriodo;
    return this.http.get<Panel2OperativoI>(direccion, {'headers': header});
  }
  //Consultar informacion panel 3 fivi
  DatosPanel3OperativoFivi(idPeriodo):Observable<Panel3OperativoI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "consultardatosoperativopanel3fivi/" + idPeriodo;
    return this.http.get<Panel3OperativoI[]>(direccion, {'headers': header});
  }


  //MODULO INDICADORES
  //Consultar informacion de indicadores chv
  /*InformacionIndicadoresChv(idPeriodo):Observable<InforIndicadoresDtoI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "informacionindicadoreschv/" + idPeriodo;
    return this.http.get<InforIndicadoresDtoI>(direccion, {'headers': header});
  }

  CalendarioTrimestresFivi():Observable<PeriodoTrimestralesFiviDto[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "calendariotrimestresfivi";
    return this.http.get<PeriodoTrimestralesFiviDto[]>(direccion, {'headers': header});
  }

  InformacionIndicadoresFivi(trimestre):Observable<InforIndicadoresDtoI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "informacionindicadoresfivi/" + trimestre;
    return this.http.get<InforIndicadoresDtoI>(direccion, {'headers': header});
  }*/

  //MODULO CUADROS DE SALIDA
  //CHV
  CuadrosSalidaChv(urlCuadroSal:String):Observable<any[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + urlCuadroSal;
    return this.http.get<any[]>(direccion, {'headers': header});
  }




  //MODULO CARGUE MASIVO
  //Servicios Cargue Masivo
  //Cargue masivo
  //Consulta periodo activo CHV
  consultarPeriodoActivoCHV():Observable<PeriodoReporteI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "periodoactivochv";
    return this.http.get<PeriodoReporteI>(direccion, {'headers': header});
  }
  //Cargue masivo
  //Consulta si reportó periodo activo CHV
  consultarReportoPeriodoActivoCHV(idfte, idperi):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "consultarfuentereportoperiodoseleccionado/" + idfte + "/" + idperi;
    return this.http.get<Boolean>(direccion, {'headers': header});
  }
  //Cargue masivo
  //Consulta periodo activo FIVI
  consultarPeriodoActivoFIVI():Observable<PeriodoReporteFiviI>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "periodoactivofivi";
    return this.http.get<PeriodoReporteFiviI>(direccion, {'headers': header});
  }
  //Cargue masivo
  //Consulta si reportó periodo activo FIVI
  /*consultarReportoPeriodoActivoFIVI(periodo:any, fuente:any):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "consultarreportoperiodoactivofivi/"+fuente;
    const body = periodo;
    return this.http.post<Boolean>(direccion, body, {'headers': header});
  }*/
  //Cargue masivo
  //Cargar archivo Excel fuente chv
  cargarArchivoCM(idUsuario: String, idFuente: BigInteger, file:File,contenido: string):Observable<ResponseCargueI>{
    let arc: Archivo = new Archivo();
    arc.idUsuarioCarga = idUsuario;
    arc.idFuente = idFuente;
    arc.nombre = file.name;
    arc.tipo = file.type;
    arc.contenido = contenido;
    arc.comentario = "";
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "carguemasivofuentechv";
    return this.http.post<ResponseCargueI>(direccion,arc, {'headers': header ,reportProgress: true, responseType: 'json'});
  }
  //Cargue masivo
  //Cargar archivo Excel supersolidaria chv
  cargarArchivoCMSuper(idUsuario: String, file:File, contenido: string):Observable<ResponseCargueI>{
    let arc: Archivo = new Archivo();
    arc.idUsuarioCarga = idUsuario;
    arc.nombre = file.name;
    arc.tipo = file.type;
    arc.contenido = contenido;
    arc.comentario = "";
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "carguemasivosuperchv";
    console.log(arc);
    return this.http.post<ResponseCargueI>(direccion,arc, {'headers': header ,reportProgress: true, responseType: 'json'});
  }
  //Cargue masivo
  //Cargar archivo Excel fuente FIVI
  cargarArchivoCMFIVI(idUsuario: String, idFuente: BigInteger, file:File,contenido: string):Observable<ResponseCargueI>{
    let arc: Archivo = new Archivo();
    arc.idUsuarioCarga = idUsuario;
    arc.idFuente = idFuente;
    arc.nombre = file.name;
    arc.tipo = file.type;
    arc.contenido = contenido;
    arc.comentario = "";
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "carguemasivofuentefivi";
    //console.log(arc);
    return this.http.post<ResponseCargueI>(direccion,arc, {'headers': header ,reportProgress: true, responseType: 'json'});
  }

  //MODULO NOVEDADES
  //Servicios Novedades Reportantes
  //Nueva noveda
  nuevoNovedadFuente(nuevo:NovedadI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "nuevanovedad";
    const body = nuevo;
    return this.http.post<Boolean>(direccion,body, {'headers': header});
  }
  //Guardar estado de cargue para fuente chv
  GuardarEstadoInformacionChv(EstaInf:EstadoInfoChvI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "guardarestadoinformacionchv";
    const body = EstaInf;
    return this.http.post<Boolean>(direccion,body, {'headers': header});
  }
  //Guardar estado de cargue para fuente Fivi
  GuardarEstadoInformacionFivi(EstaInf:EstadoInfoFiviI):Observable<Boolean>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "guardarestadoinformacionfivi";
    const body = EstaInf;
    return this.http.post<Boolean>(direccion,body, {'headers': header});
  }

  //Servicios Consulta Reportes
  //Reportes
  //Consultar lista de años registrados en historico de reportes
  listAniosForConsulta(cod_entidad):Observable<String[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "consultaranios/" + cod_entidad;
    return this.http.get<String[]>(direccion, {'headers': header});
  }
  //Reportes
  //Consultar lista años CHV
  listaAniosConsultaChv():Observable<VigenciaI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "listaAniosChv";
    return this.http.get<VigenciaI[]>(direccion, {'headers': header});
  }
  //Reportes
  //Consultar lista años CHV
  listaAniosConsultaFivi():Observable<VigenciaI[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "listaAniosFivi";
    return this.http.get<VigenciaI[]>(direccion, {'headers': header});
  }
  //Reportes
  //Consulta historico fuente CHV
  consultarHistoricoCHV(consulta:ConsultaFuenteI):Observable<ResCargueExcel[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "consultachv";
    const body = consulta;
    return this.http.post<ResCargueExcel[]>(direccion,body, {'headers': header});
  }
  //Reportes
  //Consulta historico mensual fuente FIVI
  ConsultarReportePeriodoMensual(idfuente, idperiodo):Observable<ResCargueExcelFivi[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "consultareportefivimensual/"+idfuente+"/"+idperiodo;
    return this.http.get<ResCargueExcelFivi[]>(direccion, {'headers': header});
  }
  //Reportes
  //Consulta historico trimestre fuente FIVI
  ConsultarReportePeriodoTrimestre(idfuente, idperiodo, trimestre):Observable<ResCargueExcelFivi[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "consultareportefivitrimestre/"+idfuente+"/"+idperiodo+"/"+trimestre;
    return this.http.get<ResCargueExcelFivi[]>(direccion, {'headers': header});
  }
  //Reportes
  //Consulta historico fuente FIVI
  consultarHistoricoFIVI(consulta:ConsultaFuenteI):Observable<ResCargueExcelFivi[]>{
    let header = new HttpHeaders();
    let token = "Bearer " + localStorage.getItem('token');
    header = header.set('Content-Type','application/json').set('Authorization',token);
    let direccion = this.url + "consultaReporteHistoricoFivi";
    const body = consulta;
    return this.http.post<ResCargueExcelFivi[]>(direccion,body, {'headers': header});
  }

}
function body<T>(direccion: string, arg1: { headers: HttpHeaders; }, body: any): Observable<fuenteI[]> {
  throw new Error('Function not implemented.');
}

